// extracted by mini-css-extract-plugin
export default {"scrollUpBtn":"JumpToTopButton_scrollUpBtn__ULcPQ","scrollScaler":"JumpToTopButton_scrollScaler__qIlTB","scrollUpBtnShow":"JumpToTopButton_scrollUpBtnShow__Iq7bs"};